import React from "react";
import PropTypes from "prop-types";
import Logo from "../../lender/components/Logo";

export default function Header({ onLogoClick, userEmail, onSignOut }) {
  return (
    <header
      style={{
        position: "relative",
        top: 0,
        left: 0,
        right: 0,
        background: "linear-gradient(135deg, #0b1220 0%, #0f172a 55%, #0b1220 100%)",
        borderBottom: "1px solid rgba(59,130,246,0.2)",
        boxShadow: "0 10px 40px rgba(8,12,24,0.4)",
        zIndex: 1000,
        backdropFilter: "blur(10px)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1280px",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: "24px 32px",
          gap: "16px",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}
          onClick={onLogoClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && onLogoClick?.()}
          aria-label="Go to landing page"
        >
          <Logo className="h-16 w-auto" />
        </div>
        {userEmail && (
          <div style={{ marginLeft: "auto", textAlign: "right" }}>
            <p style={{ margin: 0, color: "#e2e8f0", fontWeight: 700, fontSize: "14px" }}>{userEmail}</p>
            <button
              onClick={onSignOut}
              style={{
                marginTop: "6px",
                background: "transparent",
                border: "1px solid rgba(148,163,184,0.3)",
                color: "#cbd5e1",
                padding: "6px 10px",
                borderRadius: "10px",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: 600
              }}
            >
              Sign out
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

Header.propTypes = {
  onLogoClick: PropTypes.func,
  userEmail: PropTypes.string,
  onSignOut: PropTypes.func
};
